// inv/src/components/investor-page/modules/pFetchDeals.jsx
import axios from 'axios';
import { API_URL } from '../../../config';

export async function fetchDealsBatchByInvestor(investorId, { page = 1, perPage = 20, by = 'id' } = {}) {
  try {
    const url = `${API_URL}/investors-limited/${encodeURIComponent(investorId)}/last-deals`;
    const { data } = await axios.get(url, {
      params: { page, perPage, by },
      withCredentials: true,
    });

    return {
      total: data.total_deals_count,
      visibleCount: data.deals_to_show,
      visibleDeals: data.visible_deals || [],
      hidden: data.hidden_deals || { page: 1, perPage, total: 0, pages: 1, items: [] },
      isNewSchema: true,
    };
  } catch (error) {
    console.error('Error fetchDealsBatchByInvestor:', error);
    return {
      total: 0,
      visibleCount: 0,
      visibleDeals: [],
      hidden: { page: 1, perPage, total: 0, pages: 1, items: [] },
      isNewSchema: true,
    };
  }
}
